import axios from 'axios';

export const equipmentApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipments`,
    headers: {
        'Content-Type': 'application/json'
    }
})